import {Component, EventEmitter, inject, OnDestroy, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SelectOption} from '@xmedical/core';
import {Doctor, PatientDoctor, DoctorRepositoryService} from '@xmedical/core';

@Component({
  selector: 'app-doctor-edit-card',
  standalone: false,
  templateUrl: './doctor-edit-card.component.html',
  styleUrl: './doctor-edit-card.component.scss'
})
export class DoctorEditCardComponent implements OnInit, OnDestroy {

  private dialogRef = inject(MatDialogRef<DoctorEditCardComponent>);
  private formBuilder = inject(UntypedFormBuilder);
  private doctorRepository = inject(DoctorRepositoryService);
  private doctor = inject<Doctor | PatientDoctor>(MAT_DIALOG_DATA);

  private repositorySubscription: Subscription;
  validate = false;
  form: UntypedFormGroup;

  @Output() doctorSaved: EventEmitter<Doctor | PatientDoctor> = new EventEmitter();

  contactMethodOptions: SelectOption[] = [
    { value: 'Phone', text: 'Phone'},
    { value: 'Email', text: 'Email'},
    { value: 'Fax', text: 'Fax'}
  ];

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: [this.doctor?.name || '', Validators.required],
      practiceNumber: [this.doctor?.practiceNumber || ''],
      tel: [this.doctor?.tel || ''],
      fax: [this.doctor?.fax || ''],
      email: [this.doctor?.email || ''],
      preferredGreeting: [this.doctor?.preferredGreeting || ''],
      preferredContactMethod: [this.doctor?.preferredContactMethod || '']
    });
  }

  ngOnDestroy(): void {
    if (this.repositorySubscription) { this.repositorySubscription.unsubscribe(); }
  }

  save() {
    if (this.form.valid) {
      const updatedDoctor = this.formToDoctor();

      // Only save to database if this is a standalone doctor (has ID)
      if ('id' in this.doctor && this.doctor.id) {
        this.repositorySubscription = this.doctorRepository.updateDoctor(this.doctor.id, updatedDoctor as Doctor).subscribe(result => {
          this.dialogRef.close(updatedDoctor);
          this.doctorSaved.emit(updatedDoctor);
        });
      } else {
        // For patient doctors (no ID), just return the updated values
        this.dialogRef.close(updatedDoctor);
        this.doctorSaved.emit(updatedDoctor);
      }
    }
    console.log(this.form.errors);
    this.validate = true;
  }

  close() {
    this.dialogRef.close();
  }

  private formToDoctor(): Doctor | PatientDoctor {
    return {
      ...this.doctor,
      ...this.form.value
    };
  }
}
